import { render, staticRenderFns } from "./detailsOld.vue?vue&type=template&id=0dea16ba&scoped=true&"
import script from "./detailsOld.vue?vue&type=script&lang=js&"
export * from "./detailsOld.vue?vue&type=script&lang=js&"
import style0 from "./detailsOld.vue?vue&type=style&index=0&id=0dea16ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea16ba",
  null
  
)

export default component.exports